import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';
import { PageHeaderModule } from '../../components/header/page-header/page-header.module';
import { ListContainerModule } from '../../components/list/list-container/list-container.module';
import { NvTooltipModule } from '../../nv-tooltip/nv-tooltip.module';
import { BatchEditService } from '../../services/batch-edit-service/batch-edit-service';
import { BaseModalModule } from '../base-modal.module';
import { ClusterUserModalShellService } from './cluster-user/cluster-user-modal-shell.service';
import { ClusterUserModalShellComponent } from './cluster-user/cluster-user-modal-shell/cluster-user-modal-shell.component';
import { ClusterUserModalsDataService } from './cluster-user/cluster-user-modals.data.service';
import { UserPortfolioModalComponent } from './cluster-user/cluster-user-portfolio-modal/cluster-user-portfolio-modal.component';
import { PortfolioPermissionDropdownComponent } from './cluster-user/cluster-user-portfolio-modal/portfolio-permission-dropdown/portfolio-permission-dropdown.component';

@NgModule({
  declarations: [ClusterUserModalShellComponent, UserPortfolioModalComponent, PortfolioPermissionDropdownComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    BaseModalModule,
    MatMenuModule,
    NvDesignLibraryModule,
    NvTooltipModule,
    PageHeaderModule,
    ListContainerModule,
  ],
  exports: [ClusterUserModalShellComponent, UserPortfolioModalComponent],
  providers: [BatchEditService, ClusterUserModalsDataService, ClusterUserModalShellService],
  entryComponents: [ClusterUserModalShellComponent, UserPortfolioModalComponent, PortfolioPermissionDropdownComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UserManagementModalModule {}
